import React, {useEffect} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@mui/material/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@mui/material';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import { useHistory } from 'react-router-dom';



function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  appBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  toolbar: {
    flexWrap: 'wrap',
  },
  toolbarTitle: {
    flexGrow: 1,
  },
  link: {
    margin: theme.spacing(1, 1.5),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
  },
  cardHeader: {
    backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
    fontWeight: 'bold'
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginTop: theme.spacing(8),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
    },
  },
}));

const dayScholarFeatures = [
  '- Cambridge and ZIMSEC Curricula',
  '- Qualified Teachers',
  '- Safe and Supportive Environment',
  '- Sports',
  '- Clubs and Societies'
];

const boarderFeatures = [
  '- Cambridge and ZIMSEC Curricula',
  '- Qualified Teachers',
  '- Safe and Supportive Environment',
  '- Accommodation',
  '- Meals',
  '- Sports',
  '- Clubs and Societies'
];

const tiers = [
  {
    title: 'Form 1 - 4',
    subheader: 'Day Scholar',
    price: '350',
    period: '/term',
    description: dayScholarFeatures,
    buttonText: 'Apply',
    buttonVariant: 'outlined',
  },
  {
    title: 'Form 5 - 6',
    subheader: 'Day Scholar',
    price: '500',
    period: '/term',
    description: dayScholarFeatures,
    buttonText: 'Apply',
    buttonVariant: 'outlined',
  },
  {
    title: 'Form 1 - 4',
    subheader: 'Boarder',
    price: '790',
    period: '/term',
    description: boarderFeatures,
    buttonText: 'Apply',
    buttonVariant: 'contained',
  },
  {
    title: 'Form 5 - 6',
    subheader: 'Boarder',
    price: '1,000',
    period: '/term',
    description: boarderFeatures,
    buttonText: 'Apply',
    buttonVariant: 'contained',
  },
];


export default function Pricing() {
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {

    window.scrollTo(0, 0)

  }, [])

  return (
    <React.Fragment>
      <CssBaseline />
      {/* Hero unit */}
      <Container maxWidth="sm" component="main" className={classes.heroContent}>
        <Typography
            component="h1"
            variant="h4"
            align="center"
            color="textPrimary"
            style={{fontWeight: 'bold', marginBottom: '40px', marginTop: '64px'}}
            gutterBottom>
          Fees
        </Typography>
        <Typography variant="h6" align="center" color="textSecondary" component="p">
          Raising Kings & Queens in Wisdom and Excellency
        </Typography>
      </Container>
      {/* End hero unit */}
      <Container maxWidth="md" component="main">
        <Grid container spacing={5} alignItems="flex-end">
          {tiers.map((tier) => (
            <Grid item key={`${tier.subheader}-${tier.title}`} xs={12} sm={6} md={3}>
              <Card>
                <CardHeader
                  title={tier.title}
                  subheader={tier.subheader}
                  titleTypographyProps={{ align: 'center', fontSize: '14px'}}
                  subheaderTypographyProps={{ align: 'center' }}
                  className={classes.cardHeader}
                />
                <CardContent>
                  <div className={classes.cardPricing}>
                    <Typography component="h2" variant="h4" color="textPrimary">
                      ${tier.price}
                    </Typography>
                    <Typography variant="h6" color="textSecondary">
                      {tier.period}
                    </Typography>
                  </div>
                  <ul>
                    {tier.description.map((line) => (
                      <Typography component="li" variant="subtitle1" align="center" key={line}>
                        {line}
                      </Typography>
                    ))}
                  </ul>
                </CardContent>
                <CardActions>
                  <Button
                    fullWidth
                    variant={tier.buttonVariant}
                    color="secondary"
                    disableElevation
                    onClick={() => history.push('/apply')}
                  >
                    {tier.buttonText}
                  </Button>

                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Typography
          variant="body1"
          align="center"
          color="textSecondary"
          style={{marginTop: '48px', marginBottom: '64px'}}
        >
          Flexible payment plans are available. School fees may be settled in three installments per term.
        </Typography>
      </Container>
    </React.Fragment>
  );
}